import React, { useState, useRef } from "react";

const Contact = () => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const apiURL = "https://j88m3fh0ga.execute-api.us-east-2.amazonaws.com/PROD";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmissionStatus(null);

    try {
      const formData = new FormData(formRef.current);
      const formDataObject = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      const response = await fetch(apiURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDataObject),
      });

      if (response.ok) {
        setSubmissionStatus("success");
        if (formRef.current) { //added check
          formRef.current.reset();
        }
      } else {
        setSubmissionStatus("error");
      }
    } catch (err) {
      console.error(err);
      setSubmissionStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact">

      <form
        ref={formRef}
        onSubmit={handleSubmit}
        name="save-google-sheet"
        id="save-google-sheet"
        className=""
      >
        <div class="status">
          {submissionStatus === 'error' && (
            <p class="error" style={{ color: "red" }}>Form submission failed.</p>
          )}
          <p className="thanks">
            {loading ? "Loading..." : ""}
          </p>
          <p className="thanks">
            {submissionStatus === 'success' ? "Thank you for your interest. I will get back to you as soon as possible." : " "}
          </p>
        </div>
        <h2 className="">Contact Us</h2>
        <p className="info">
          We can be reached at: Phone: 516.442.9621 Email: info@ocdnewyork.org
        </p>
        <div className="fields">
          <div className="comment">
            <label htmlFor="comment">Leave a Reply</label>
            <textarea id="comment" name="comment" placeholder="Comment *" />
          </div>
          <div className="contact-info">
            <input type="text" id="name" name="name" placeholder="Name *" />
            <input
              type="email"
              id="email"
              name="email"
              placeholder="E-Mail *"
            />
            <input
              type="text"
              id="website"
              name="website"
              placeholder="Website"
            />
          </div>
        </div>
        <div className="submit">
          <input
            className="button"
            type="submit"
            value={loading ? "Loading..." : "Submit"}
          />
        </div>
      </form>

    </div>
  );
};

export default Contact;